import { graphql } from 'gatsby'
import React, { forwardRef, useMemo } from 'react'
import styled from 'styled-components'

import { MenuEntryFragmentFragment } from '../../../graphql/gatsby'
import { useSanityRoleAndContextBasedContent } from '../../../lib/sanity'
import SanityLink, { SanityLinkProps, SanityLinkRef } from '../SanityLink'

export type MenuEntryLinkProps = Omit<SanityLinkProps, 'ref' | 'to'> & {
  link: MenuEntryFragmentFragment['link']
  roleBasedContent?: MenuEntryFragmentFragment['roleBasedContent']
  contextBasedContent?: MenuEntryFragmentFragment['contextBasedContent']
}

const MenuEntryLink = forwardRef<SanityLinkRef, MenuEntryLinkProps>(function MenuEntryLink(
  { link, contextBasedContent, roleBasedContent, children, ...otherProps },
  ref,
) {
  const { shouldDisplayContent } = useSanityRoleAndContextBasedContent()
  const shouldDisplay = useMemo(
    () => shouldDisplayContent({ contextBasedContent, roleBasedContent }),
    [contextBasedContent, roleBasedContent, shouldDisplayContent],
  )
  if (!shouldDisplay) {
    return null
  }

  if (link) {
    return (
      <SanityLink to={link} ref={ref} {...otherProps}>
        {children}
      </SanityLink>
    )
  }
  // return link to nowhere if link not specified
  return (
    <SanityLink to="#0" ref={ref} onClick={(e) => e.preventDefault()} {...otherProps}>
      {children}
    </SanityLink>
  )
})

const StyledMenuEntryLink = styled(MenuEntryLink)``

export default StyledMenuEntryLink

export const menuEntry = graphql`
  fragment MenuEntryFragment on SanityMenuEntry {
    _id
    name
    newColumn
    roleBasedContent {
      ...RoleBasedContentFragment
    }
    contextBasedContent {
      ...ContextBasedContentFragment
    }
    link {
      ...LinkFragment
    }
  }
`
